import { ActionService } from 'dashboard-services/services';

export default (() => {

  const CHANGE_VALUE = 'CHANGE_VALUE_EXECUTE_MODAL_PIPELINE_LIST'
  const changeValue = ActionService.makeActionCreator(CHANGE_VALUE, 'name', 'value')

  return {
    changeValue,
    CHANGE_VALUE
  }
})()